import axios from "axios";
import { headerConfig, mediaHeaderConfig } from "../utility/RequestHeaderConfig";
import { BASE_API_URL } from "../utility/URL";





const RegBasicInfoSave = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "member/action", data, headerConfig);
    return response;
  };



  const RegBasicInfoSaveWithFile = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "member/action", data, mediaHeaderConfig);
    return response;
  };

  const registrationCount = async () => {
    const response = await axios
        .post(BASE_API_URL + "member/reg-count", {}, headerConfig);
    return response;
  };





const RegistrationService = {
    RegBasicInfoSave,
    registrationCount,
    RegBasicInfoSaveWithFile 
    
    
};

export default RegistrationService;